<script>
  export let list_options // {value:'Value', display:'[html]Display'}
  export let selected_option
  export let pill_shaped = false
  export let small = false
</script>

<ul class:pill_shaped class:small>
  {#each list_options as list_option, i}
    {#if i > 0 && !pill_shaped}
      <li class="slash">&nbsp;/</li>
    {/if}
    <li 
      on:click={() => selected_option = list_option.value}
      class:active={String(selected_option) === String(list_option.value)}>
      {@html list_option.display}
    </li>
  {/each}
</ul>

<style>
	ul {
    display: inline-block;
    cursor: default;
    user-select: none;
	}
  li {
    display: inline-block;
    color: var(--c-text-faded);
  }
  li.slash {
    color: var(--c-text-faded-big);
  }
  li:not(.slash):not(.active):hover {
    cursor: pointer;
    color: var(--c-text);
  }
  li.active {
    color: var(--c-accent);
  }

  ul.pill_shaped {
    background: var(--c-pill-bg);
    border-radius: 2rem;
    padding: 0.2rem;
  }
  ul.pill_shaped li {
    margin: 0 0.25rem;
    color: var(--c-text);
  }
  ul.pill_shaped li:not(.active):hover {
    color: var(--c-accent) !important;
  }
  ul.pill_shaped li:first-of-type {
    margin-left: 0;
  }
  ul.pill_shaped li:last-of-type {
    margin-right: 0;
  }
  ul.pill_shaped li:not(.active):first-of-type {
    margin: 0 0.75rem 0 1.5rem;
  }
  ul.pill_shaped li:not(.active):last-of-type {
    margin: 0 1.5rem 0 0.75rem;
  }
  ul.pill_shaped li.active {
    padding: 0.5rem 1.5rem;
    border-radius: 2rem;
    background: var(--c-button-bg);
    color: var(--c-text-on-fill);
  }

  ul.pill_shaped.small {
    border-radius: 1.5rem;
  }
  ul.pill_shaped.small li:not(.active):first-of-type {
    margin: 0;
    margin-left: 0.75rem;
  }
  ul.pill_shaped.small li:not(.active):last-of-type {
    margin: 0;
    margin-right: 0.75rem;
  }
  ul.pill_shaped.small li.active {
    border-radius: 1.5rem;
    padding: 0.25rem 0.75rem;
  }
  
</style>